import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ApolloProvider } from '@apollo/client';

import { setupSentry } from './config/setup-sentry';
import { setupGA } from './config/setup-ga';
import { client } from './config/setup-apollo';
import 'bootstrap/dist/css/bootstrap.min.css';

setupSentry();
setupGA();

const root = createRoot(document.getElementById('root'));

root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
);
